import React from 'react'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import { Navigate, Outlet, Route, Routes } from 'react-router'
import MyAudiences from './MyAudiences'
import AudienceDetails from './Audience/AudienceDetails'
import AddAudience from '../../../../forms/AddAudience'
import SiteAudiences from './SiteAudiences'
import PlatformAudiences from './PlatformAudiences'
import { VENDOR } from '../../../../lib/utils/vendors'
import TradeDeskAudience from './Audience/ThirdParty/TradeDeskAudience'
import AmazonAudience from './Audience/ThirdParty/AmazonAudience'
import GoogleAudience from './Audience/ThirdParty/GoogleAudience'
import { ReactComponent as AudiencesIcon } from '../../../../images/icons/audiences_icon.svg'

function AudiencesTemplate(): JSX.Element {
  return (
    <div className="flex flex-1 flex-col h-full">
      <PageHeader
        icon={
          <div className="flex justify-center items-center rounded-full w-12 h-12 bg-black">
            <AudiencesIcon className="stroke-white" />
          </div>
        }
        title="Audiences"
        tabMenu={[
          { name: 'Tag', to: 'tag' },
          { name: 'Programmatic', to: 'programmatic' },
          { name: 'Custom', to: 'custom' },
        ]}
      />
      <Outlet />
    </div>
  )
}

export default function Audiences(): JSX.Element {
  return (
    <Routes>
      <Route path="/custom/details/:audience_id" element={<AudienceDetails />} />
      <Route
        path={`programmatic/${VENDOR.TradeDesk}/:audience_id/*`}
        element={<TradeDeskAudience />}
      />
      <Route
        path={`/programmatic/${VENDOR.AmazonCognition}/:audience_id/*`}
        element={<AmazonAudience />}
      />
      <Route
        path={`/programmatic/${VENDOR.Google}/:audience_id/*`}
        element={<GoogleAudience />}
      />
      <Route element={<AudiencesTemplate />}>
        <Route path="/custom/*" element={<MyAudiences />}>
          <Route path="create/*" element={<AddAudience />} />
        </Route>
        <Route path="/programmatic/*" element={<PlatformAudiences />} />
        <Route path="/tag/*" element={<SiteAudiences />} />
        <Route path="*" element={<Navigate to="custom" replace />} />
      </Route>
    </Routes>
  )
}
